import { getAutomobileCatalog } from './automobileCatalog';
import type { AutomobileBodyType, AutomobileCompanyStatus, AutomobileVerificationLevel } from '../types/automobile';

export type AutomobileBrandRow = {
  id: string;
  slug: string;
  name: string;
  country_code: string | null;
  logo_url: string | null;
  logo_focal_x?: number | null;
  logo_focal_y?: number | null;
  logo_zoom?: number | null;
  description: string | null;
  founded: number | null;
  headquarters: string | null;
  website: string | null;
  highlights: string[] | null;
  legal_name: string | null;
  company_status: AutomobileCompanyStatus | null;
  parent_company: string | null;
  successor_brand: string | null;
  closed_year: number | null;
  closure_reason: string | null;
  verification_level: AutomobileVerificationLevel | null;
  sources: { title: string; url: string }[] | null;
  is_hidden?: boolean | null;
  created_at: string;
  updated_at?: string;
};

export type AutomobileModelRow = {
  id: string;
  brand_id: string;
  model_key?: string | null;
  name: string;
  display_name?: string | null;
  generation_code?: string | null;
  variant_label?: string | null;
  year_from?: number | null;
  year_from_month?: number | null;
  year_to?: number | null;
  body_type: AutomobileBodyType;
  image_url: string | null;
  image_generic?: boolean | null;
  image_focal_x?: number | null;
  image_focal_y?: number | null;
  image_zoom?: number | null;
  production_years?: number[] | null;
  is_hidden?: boolean | null;
  created_at: string;
  updated_at?: string;
};

/** Statik catalog.json → admin tablo satırları */
export function loadCatalogAdminRows(): {
  brands: AutomobileBrandRow[];
  models: AutomobileModelRow[];
} {
  const catalog = getAutomobileCatalog();
  const now = new Date(0).toISOString();

  const brands: AutomobileBrandRow[] = catalog.brands.map((b) => {
    const id = `catalog-${b.slug}`;
    return {
      id,
      slug: b.slug,
      name: b.name,
      country_code: b.country || null,
      logo_url: b.logoUrl || null,
      description: b.description || null,
      founded: b.founded ?? null,
      headquarters: b.headquarters || null,
      website: b.website || null,
      highlights: b.highlights?.length ? b.highlights : [],
      legal_name: b.legalName || null,
      company_status: b.companyStatus || null,
      parent_company: b.parentCompany || null,
      successor_brand: b.successorBrand || null,
      closed_year: b.closedYear ?? null,
      closure_reason: b.closureReason || null,
      verification_level: b.verificationLevel || null,
      sources: b.sources?.length ? b.sources : [],
      created_at: now,
    };
  });

  const models: AutomobileModelRow[] = [];
  for (const b of catalog.brands) {
    const brandId = `catalog-${b.slug}`;
    for (const m of b.models) {
      const idSuffix = [m.name, m.generationCode, m.variantLabel, m.yearFrom, m.yearFromMonth]
        .filter((x) => x != null && x !== '')
        .join('|');
      models.push({
        id: `catalog-${b.slug}|${idSuffix}`,
        brand_id: brandId,
        name: m.name,
        body_type: m.bodyType,
        image_url: m.imageUrl || null,
        production_years: m.productionYears?.length ? m.productionYears : null,
        created_at: now,
      });
    }
  }

  return { brands, models };
}

export function isCatalogRowId(id: string): boolean {
  return id.startsWith('catalog-');
}
